import { useContext } from 'react';

import { UserContext } from '~/auth/userContext';
import { useFeatureFlags } from '~/utils/featureFlags';
import { canAccess, CAPTURE_KNOWLEDGE } from '~/utils/role';

/** Consultants only: entries are private to the consulting company that wrote them. */
export function useKnowledgeEnabled(): boolean {
  const { knowledgeCapture } = useFeatureFlags();
  const { userDetails } = useContext(UserContext);
  return knowledgeCapture && canAccess(userDetails.role, CAPTURE_KNOWLEDGE);
}
